import { useEffect } from "react";
import { Helmet } from "react-helmet";
import "../pages/Privacy.css";
import Navbar from "../components/Navbar";
import Footer from "../components/Footer";

export default function Privacy() {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <>
      <Helmet>
        <title>Privacy Policy | RAD EnviroNex | Data Protection & Security</title>
        <meta name="description" content="Read the privacy policy of RAD EnviroNex. We are committed to protecting your personal information and ensuring data security for all our environmental services." />
        <meta name="keywords" content="Privacy Policy RAD EnviroNex, Data Security Madurai, Environmental consultancy privacy, solar company data protection" />
        <link rel="canonical" href="https://radenvironex.com/Privacy" />
      </Helmet>
      <Navbar />


      {/* PRIVACY POLICY SECTION */}
      <section id="privacy-policy-section">
        <div className="privacy-wrapper" data-aos="fade-up">

          <h1>Privacy Policy</h1>
          <p className="privacy-intro">
            At <strong>RAD EnviroNex</strong>, we are committed to protecting your
            privacy and ensuring the security of any personal information you
            share with us. This Privacy Policy explains how we collect, use,
            store, and protect your information when you interact with our
            website, services, and communications.
          </p>

          <div className="privacy-block" data-aos="slide-up">
            <h3>1. Information We Collect</h3>
            <ul>
              <li>Personal details such as name, phone number, email address, and company name</li>
              <li>Project-related information shared through enquiry or contact forms</li>
              <li>Technical data such as IP address, browser type, and device information</li>
            </ul>
          </div>

          <div className="privacy-block" data-aos="slide-up" data-aos-delay="100">
            <h3>2. How We Use Your Information</h3>
            <ul>
              <li>To respond to enquiries and provide technical or commercial proposals</li>
              <li>To design and deliver customized environmental solutions (STP, ETP, Biogas, Solar, etc.)</li>
              <li>To improve our website, services, and user experience</li>
              <li>To comply with applicable legal and regulatory requirements</li>
            </ul>
          </div>

          <div className="privacy-block" data-aos="slide-up" data-aos-delay="200">
            <h3>3. Data Sharing & Disclosure</h3>
            <p>
              RAD EnviroNex does <strong>not sell, rent, or trade</strong> your
              personal information. Data may be shared only with:
            </p>
            <ul>
              <li>Authorized internal team members for project execution</li>
              <li>Government authorities or regulators when required by law</li>
              <li>Trusted service partners strictly for project-related execution</li>
            </ul>
          </div>

          <div className="privacy-block" data-aos="slide-up" data-aos-delay="300">
            <h3>4. Data Security</h3>
            <p>
              We implement appropriate technical and organizational security
              measures to protect your data against unauthorized access,
              alteration, disclosure, or destruction. Access to personal data
              is restricted to authorized personnel only.
            </p>
          </div>

          <div className="privacy-block" data-aos="slide-up" data-aos-delay="400">
            <h3>5. Cookies & Tracking</h3>
            <p>
              Our website may use cookies or similar technologies to enhance
              user experience, analyze website traffic, and improve performance.
              You can control cookie preferences through your browser settings.
            </p>
          </div>

          <div className="privacy-block" data-aos="slide-up" data-aos-delay="500">
            <h3>6. Your Rights</h3>
            <ul>
              <li>Request access to your personal data</li>
              <li>Request correction or deletion of your information</li>
              <li>Withdraw consent where applicable</li>
            </ul>
          </div>

          <div className="privacy-block" data-aos="slide-up" data-aos-delay="600">
            <h3>7. Policy Updates</h3>
            <p>
              RAD EnviroNex may update this Privacy Policy periodically. Any
              changes will be posted on this page with an updated effective date.
            </p>
          </div>

          <div className="privacy-block" data-aos="slide-up" data-aos-delay="700">
            <h3>8. Contact Information</h3>
            <p>
              For any questions regarding this Privacy Policy or how your data
              is handled, please contact us at:
            </p>
            <p className="privacy-contact">
              <strong>RAD EnviroNex</strong><br />
              Email: info@radenvironex.com
            </p>
          </div>

        </div>
      </section>

      <Footer />
    </>
  );
}
